function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 51.1667V22.8895C1.5 20.7719 2.55831 18.7945 4.32023 17.6198L26.4869 2.84206C28.6143 1.42382 31.3857 1.42382 33.5131 2.84206L55.6798 17.6198C57.4417 18.7945 58.5 20.7719 58.5 22.8895V51.1667M1.5 51.1667C1.5 54.6645 4.33553 57.5 7.83333 57.5H52.1667C55.6645 57.5 58.5 54.6645 58.5 51.1667M1.5 51.1667L22.875 36.9167M58.5 51.1667L37.125 36.9167M1.5 22.6667L22.875 36.9167M58.5 22.6667L37.125 36.9167M37.125 36.9167L33.5131 39.3246C31.3857 40.7428 28.6143 40.7428 26.4869 39.3246L22.875 36.9167",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgMailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpen);
export default __webpack_public_path__ + "static/media/mail-open.9cd3626a.svg";
export { ForwardRef as ReactComponent };